import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/catalog";

const MarqueeRibbon = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-white/10 py-6"
  >
    <Marquee speed={26} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="mx-10 text-sm uppercase tracking-[0.3em] text-white/45">
            {item}
          </span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#cba153]" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeRibbon;
